import React from 'react'
import { isMobile } from 'react-device-detect'

const Pagination = (props) => {
    const start = Math.max(1, props.page - 10)
    let end = Math.max(Math.min(15, props.pageCount), Math.min(props.pageCount, start + 14))

    if (isMobile) {
        end = Math.max(Math.min(6, props.pageCount), Math.min(props.pageCount, start + 5))
    }

    const Links = () => {
        const links = []
        for (let i = start; i <= end; i++) {
            links.push(
                <a
                    key={i}
                    href='#'
                    onClick={props.handleClick}
                    data-page={i}
                    className={props.page == i ? 'active' : ''}
                >
                    {i}
                </a>
            )
        }

        return links
    }

    const StartLink = (
        <a
            href='#'
            onClick={props.handleClick}
            data-page='1'
            className={props.page == 1 ? 'active' : ''}
        >
            First
        </a>
    )

    const EndLink = (
        <a
            href='#'
            onClick={props.handleClick}
            data-page={props.pageCount}
            className={props.page == props.pageCount ? 'active' : ''}
        >
            Last
        </a>
    )

    const style = (props.pageCount == 1 ? { display: 'none' } : {})

    return (
        <div className='pagination mt-4 text-center' style={style}>
            {!isMobile ? StartLink : ''}
            {Links()}
            {!isMobile ? EndLink : ''}
        </div>
    )
}

export default Pagination



// WEBPACK FOOTER //
// ./resources/js/components/Pagination.js